import type { Participant } from '@seen/core/models/patients/participant'
import { genderOptions } from '@seen/core/models/profile'
import type { ExtendedRelatedPerson } from '@seen/core/models/relatedPerson'
import { TypographyDetail } from '@seen/ui'
import type { JSX } from 'react'
import { ComboboxButton } from '#src/components/ComboboxButton.tsx'
import { ResourceFieldForm } from '#src/components/core/form/ResourceFieldForm.tsx'

interface GenderDisplayProps {
  profile: Participant | ExtendedRelatedPerson
}

export function GenderDisplay({ profile }: GenderDisplayProps): JSX.Element {
  return (
    <div className="group flex items-center gap-1">
      <div className="grid flex-1">
        <TypographyDetail className="leading-none font-semibold text-zinc-950">
          Gender
        </TypographyDetail>
        <div className="py-1.5">
          <ResourceFieldForm
            instance={profile}
            valueFn={(profile) => profile.gender}
            patchFn={(profile, value) => {
              profile.gender = value
            }}
            render={({ field }) => (
              <ComboboxButton
                options={genderOptions}
                variant="underline"
                className="w-full"
                {...field}
              />
            )}
          />
        </div>
      </div>
    </div>
  )
}
